import { gql } from '@apollo/client'

const LOCATION_DETAILS_FRAGMENT = gql`
  fragment LocationDetailsFragment on Location {
    id
    autoeatId
    name
    website
    status
    isPublished
    isDeleted
    isFake
    updatedAt
    createdAt

    mainLocationType {
      id
      name
    }

    cuisineType {
      id
      name
    }

    additionalLocationTypes {
      id
      name
    }

    awards {
      id
      name
    }
  }
`

export default LOCATION_DETAILS_FRAGMENT
